const theme = {
  token: {
    colorPrimary: "#1677ff",
    fontFamily: "g",
    colorLink: "#4096ff",
  },
};

export default theme;
